import React from 'react';
import { ResponsiveContainer, PieChart as Chart, Pie, Cell } from 'recharts';

import { useFinancialDashboard } from '@helpers/hooks/pages/dashboard/financialDashboard/useFinancialDashboard';

import * as S from './styles';

const CreditCard: React.FC = () => {
  const { financialDetailsReport } = useFinancialDashboard();

  const { card } = financialDetailsReport;

  const data = [
    {
      name: 'Conversão',
      value: card.conversion || 0,
    },
    {
      name: 'Total',
      value: 100 - card.conversion,
    },
  ];

  const colors = ['#5B8DEF', '#515562'];

  return (
    <S.ChartWrapper>
      <ResponsiveContainer width="100%">
        <Chart>
          <Pie
            data={data}
            innerRadius="90%"
            outerRadius="100%"
            fill="#000"
            paddingAngle={0}
            dataKey="value"
            strokeOpacity={0}
          >
            {data.map((pie, index) => (
              <Cell key={`cell-${pie.name}`} fill={colors[index]} />
            ))}
          </Pie>
        </Chart>
      </ResponsiveContainer>
    </S.ChartWrapper>
  );
};

export default CreditCard;
